import {types} from './types';

export const setGetListCodeCountryAction = (payload) => {
    return {
        type: types.SET_LIST_CODE_COUNTRY,
        payload,
      }
}

